// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cp-auth-container {
  display: flex;
  background: black;
  flex-direction: column;
  align-items: center;
  max-height: 1000vh;
  height: auto;
  position: relative;
  overflow-y: scroll;
}

.pc-form-container {
  background: rgba(234, 229, 234, 0.75); /* 60% translucent */
  padding: 40px;
  border-radius: 20px;
  width: 700px;
  /* max-width: 90%; */
  min-height: 800px;
  text-align: center;
  gap: 20px; 
}

/* Two Inputs in One Row */
.pc-form-group-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  /* margin-top: 5px; */
  width: 90%;
  justify-self: center;
}

.pc-form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* margin-top: 5px;  */
}

.pc-form-container h2 {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  color: black;
  font-size: 60px;
  margin-bottom: 10px;
  font-weight: lighter;
}

.pc-form-group label {
  font-size: 15px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: black;
  text-align: left; /* Forces left alignment */
}

/* Input Fields */
input[type="text"],
input[type="loc"],
input[type="tel"],
select {
  width: 100%;
  min-height: 40px; 
  padding: 14px;
  border: 1px solid #d1d7d5;
  border-radius: 8px;
  font-size: 18px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

input[type="password"],
select {
  width: 100%;
  margin-top: 0;
  min-height: 30px;
  height: 40px; 
  padding: 14px;
  border: 1px solid #d1d7d5;
  border-radius: 8px;
  font-size: 18px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

input[type="date"],
select {
  width: 100%;
  /* height: 40px;  */
  padding: 14px;
  border: 1px solid #d1d7d5;
  border-radius: 8px;
  font-size: 14px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

select[type="scroll"],
select {
  margin-top: 2px;
  width: 100%;
  height: auto;
  max-height: 40px; 
  padding: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

/* For first name and last name */
input[type="text"]:focus, 
input[type="email"]:focus, 
input[type="password"]:focus, 
input[type="tel"]:focus, 
input[type="date"]:focus, 
select:focus {
  border-radius: 10px;
  outline: none;
  border-color: #28a745;
}

/* Terms & Conditions Styling */
.pc-terms-conditions {
  margin-top: 15px;
  display: flex;
  gap: 10px; /* Space between checkbox and label */
  font-size: 14px;
  color: #fff;
  margin-bottom: 20px; /* Space before the Sign-Up button */
  align-items: baseline; /* Align the checkbox and label from the baseline */
}

/* Terms & Conditions Styling */
.pc-checkbox-container {
  margin-top: 15px;
  display: flex;
  gap: 10px; /* Space between checkbox and label */
  font-size: 14px;
  color: #fff;
  margin-bottom: 20px; /* Space before the Sign-Up button */
  align-items: baseline; /* Align the checkbox and label from the baseline */
}

/* Checkbox styling */
.pc-terms-conditions input {
  transform: scale(1.2); /* Make checkbox slightly larger */
  cursor: pointer;
  margin: 0; /* Remove default margin */
}

/* Ensure label is properly aligned */
.pc-terms-conditions label {
  cursor: pointer;
  display: flex;
  align-items: center;
}

/* Link Styling */
.pc-terms-conditions a {
  color: #007bff;
  text-decoration: none;
}

.pc-terms-conditions a:hover {
  text-decoration: underline;
}

.pc-signin-prompt {
  border-radius: 10px;
  width: 100%;
  height: 40px; 
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  color: black;
  padding: 5px;
  font-family: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"; 
}

.pc-signin-prompt a {
  color: #007BFF; /* Link color */
  text-decoration: none;
}

.pc-signin-prompt a:hover {
  text-decoration: underline; /* Underline on hover */
}

/* Button Container */
.pc-button-container {
  border-radius: 10px;
  display: flex;
  justify-content: flex-start; /* Aligns button to the right */
  width: 100%; /* Ensures it takes full width of parent */
}

/* Button - Matches Gender input box size */
pc-submit-btn {
  width: 50%;
  height: 35px; /* Same height as input fields */
  /* padding: 10px; */
  border: 1px solid #020202;
  border-radius: 8px;
  font-size: 14px;
  background-color: #28a745;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

pc-submit-btn:disabled {
  background-color: #ccc !important; /* Gray out */
  cursor: not-allowed; /* Show disabled cursor */
  border: 1px solid #999;
}

/* Responsive: Stack fields on smaller screens */
@media (max-width: 600px) {
  .form-group-row {
    flex-direction: column;
  }
}

.pc-profilepic {
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 6px;
  background-color: #fff;
  height: 40px;
}

.pc-uploadimage {
  flex-grow: 1;
  /* height: 20px; */
  border: none;
  outline: none;
  padding: 8px;
  font-size: 14px;
  background: transparent;
  border-radius: 10px;
  margin-top: 10px;
}

.pc-mediaupload {
  flex-grow: 1;
  /* height: 20px; */
  border: none;
  outline: none;
  padding: 8px;
  font-size: 14px;
  background: white;
  border-radius: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}

.pc-imageupload {
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: right;
  justify-content: right;
}

.pc-upload-icon {
  color: gray;
  font-size: 18px;
}

.pc-input-field {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}



.pc-submit-btn {
  margin-top: 0px;
  background-color: #007bff;
  color: white;
  padding: 10px;
  border: 1px solid black;
  min-height: 10px;
  border-radius: 10px;
  cursor: pointer;
}

.pc-copyright-container {
    color: "black"; 
    font-family: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"; 
    display: "block";
    font-size: "16px"; 
    text-align: "center";
}

.pc-copyright {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/DeleteProfile/DeleteProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC,EAAE,oBAAoB;EAC3D,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6EAA6E;EAC7E,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mJAAmJ;EACnJ,YAAY;EACZ,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA,iBAAiB;AACjB;;;;EAKE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;;EAGE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;;EAGE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;;EAEE,eAAe;EAEf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,iCAAiC;AACjC;;;;;;EAME,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS,EAAE,qCAAqC;EAChD,eAAe;EACf,WAAW;EACX,mBAAmB,EAAE,oCAAoC;EACzD,qBAAqB,EAAE,mDAAmD;AAC5E;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAEhB,aAAa;EACb,SAAS,EAAE,qCAAqC;EAChD,eAAe;EACf,WAAW;EACX,mBAAmB,EAAE,oCAAoC;EACzD,qBAAqB,EAAE,mDAAmD;AAC5E;;AAEA,qBAAqB;AACrB;EACE,qBAAqB,EAAE,kCAAkC;EACzD,eAAe;EACf,SAAS,EAAE,0BAA0B;AACvC;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,qJAAqJ;AACvJ;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B,EAAE,+BAA+B;EAC5D,WAAW,EAAE,0CAA0C;AACzD;;AAEA,2CAA2C;AAC3C;EAEE,UAAU;EACV,YAAY,EAAE,gCAAgC;EAC9C,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC,EAAE,aAAa;EAChD,mBAAmB,EAAE,yBAAyB;EAC9C,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;;;AAIA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,cAAc;IACd,qJAAqJ;IACrJ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".cp-auth-container {\n  display: flex;\n  background: black;\n  flex-direction: column;\n  align-items: center;\n  max-height: 1000vh;\n  height: auto;\n  position: relative;\n  overflow-y: scroll;\n}\n\n.pc-form-container {\n  background: rgba(234, 229, 234, 0.75); /* 60% translucent */\n  padding: 40px;\n  border-radius: 20px;\n  width: 700px;\n  /* max-width: 90%; */\n  min-height: 800px;\n  text-align: center;\n  gap: 20px; \n}\n\n/* Two Inputs in One Row */\n.pc-form-group-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 20px;\n  /* margin-top: 5px; */\n  width: 90%;\n  justify-self: center;\n}\n\n.pc-form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* margin-top: 5px;  */\n}\n\n.pc-form-container h2 {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  color: black;\n  font-size: 60px;\n  margin-bottom: 10px;\n  font-weight: lighter;\n}\n\n.pc-form-group label {\n  font-size: 15px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  color: black;\n  text-align: left; /* Forces left alignment */\n}\n\n/* Input Fields */\ninput[type=\"text\"],\ninput[type=\"loc\"],\ninput[type=\"tel\"],\nselect {\n  border-radius: 10px;\n  width: 100%;\n  min-height: 40px; \n  padding: 14px;\n  border: 1px solid #d1d7d5;\n  border-radius: 8px;\n  font-size: 18px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\ninput[type=\"password\"],\nselect {\n  border-radius: 10px;\n  width: 100%;\n  margin-top: 0;\n  min-height: 30px;\n  height: 40px; \n  padding: 14px;\n  border: 1px solid #d1d7d5;\n  border-radius: 8px;\n  font-size: 18px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\ninput[type=\"date\"],\nselect {\n  border-radius: 10px;\n  width: 100%;\n  /* height: 40px;  */\n  padding: 14px;\n  border: 1px solid #d1d7d5;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\nselect[type=\"scroll\"],\nselect {\n  margin-top: 2px;\n  border-radius: 10px;\n  width: 100%;\n  height: auto;\n  max-height: 40px; \n  padding: 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\n/* For first name and last name */\ninput[type=\"text\"]:focus, \ninput[type=\"email\"]:focus, \ninput[type=\"password\"]:focus, \ninput[type=\"tel\"]:focus, \ninput[type=\"date\"]:focus, \nselect:focus {\n  border-radius: 10px;\n  outline: none;\n  border-color: #28a745;\n}\n\n/* Terms & Conditions Styling */\n.pc-terms-conditions {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px; /* Space between checkbox and label */\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 20px; /* Space before the Sign-Up button */\n  align-items: baseline; /* Align the checkbox and label from the baseline */\n}\n\n/* Terms & Conditions Styling */\n.pc-checkbox-container {\n  margin-top: 15px;\n  margin-bottom: 2px;\n  display: flex;\n  gap: 10px; /* Space between checkbox and label */\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 20px; /* Space before the Sign-Up button */\n  align-items: baseline; /* Align the checkbox and label from the baseline */\n}\n\n/* Checkbox styling */\n.pc-terms-conditions input {\n  transform: scale(1.2); /* Make checkbox slightly larger */\n  cursor: pointer;\n  margin: 0; /* Remove default margin */\n}\n\n/* Ensure label is properly aligned */\n.pc-terms-conditions label {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n/* Link Styling */\n.pc-terms-conditions a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.pc-terms-conditions a:hover {\n  text-decoration: underline;\n}\n\n.pc-signin-prompt {\n  border-radius: 10px;\n  width: 100%;\n  height: 40px; \n  margin-top: 10px;\n  text-align: center;\n  font-size: 16px;\n  color: black;\n  padding: 5px;\n  font-family: \"system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif\"; \n}\n\n.pc-signin-prompt a {\n  color: #007BFF; /* Link color */\n  text-decoration: none;\n}\n\n.pc-signin-prompt a:hover {\n  text-decoration: underline; /* Underline on hover */\n}\n\n/* Button Container */\n.pc-button-container {\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start; /* Aligns button to the right */\n  width: 100%; /* Ensures it takes full width of parent */\n}\n\n/* Button - Matches Gender input box size */\npc-submit-btn {\n  border-radius: 10px;\n  width: 50%;\n  height: 35px; /* Same height as input fields */\n  /* padding: 10px; */\n  border: 1px solid #020202;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color: #28a745;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\npc-submit-btn:disabled {\n  background-color: #ccc !important; /* Gray out */\n  cursor: not-allowed; /* Show disabled cursor */\n  border: 1px solid #999;\n}\n\n/* Responsive: Stack fields on smaller screens */\n@media (max-width: 600px) {\n  .form-group-row {\n    flex-direction: column;\n  }\n}\n\n.pc-profilepic {\n  /* margin-top: 10px; */\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  padding: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n  height: 40px;\n}\n\n.pc-uploadimage {\n  flex-grow: 1;\n  /* height: 20px; */\n  border: none;\n  outline: none;\n  padding: 8px;\n  font-size: 14px;\n  background: transparent;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n.pc-mediaupload {\n  flex-grow: 1;\n  /* height: 20px; */\n  border: none;\n  outline: none;\n  padding: 8px;\n  font-size: 14px;\n  background: white;\n  border-radius: 10px;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.pc-imageupload {\n  cursor: pointer;\n  padding: 6px;\n  display: flex;\n  align-items: right;\n  justify-content: right;\n}\n\n.pc-upload-icon {\n  color: gray;\n  font-size: 18px;\n}\n\n.pc-input-field {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n\n\n.pc-submit-btn {\n  margin-top: 0px;\n  background-color: #007bff;\n  color: white;\n  padding: 10px;\n  border: 1px solid black;\n  min-height: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.pc-copyright-container {\n    color: \"black\"; \n    font-family: \"system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif\"; \n    display: \"block\";\n    font-size: \"16px\"; \n    text-align: \"center\";\n}\n\n.pc-copyright {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
